export default "__VITE_ASSET__Cu$G4PMb__"